<div class="app-layout">
  <app-header *ngIf="isFirstAccess"></app-header>
  <div class="app-content" [class.has-sidebar]="isSidebarVisible"
    [class.sidebar-collapsed]="isSidebarVisible && isSidebarCollapsed">
    <router-outlet></router-outlet>
    <app-floating-file-uploader *ngIf="isMember"></app-floating-file-uploader>
    <app-footer></app-footer>
  </div>
</div>
